<template>
  <div>
    <PpcHero />
    <Ppc1 />
    <Ppc2 />
    <Ppc3 />
  </div>
</template>

<script>
import PpcHero from '@/components/Ppc/PpcHero.vue'
import Ppc1 from '@/components/Ppc/Ppc1.vue'
import Ppc2 from '@/components/Ppc/Ppc2.vue'
import Ppc3 from '@/components/Ppc/Ppc3.vue'

export default {
  name: 'Ppc',
  components: {
    PpcHero,
    Ppc1,
    Ppc2,
    Ppc3,
  },
}
</script>
